// @ts-nocheck

import { AuthActionTypes } from '../types/actions/auth';

/**
 * [Dispatch this action to process the new jwt]
 * @param  {[string]} jwt               [jwt]
 * @param  {[number]} expirationDelay   [Expiration delay]
 * @return {[object]}                   [Action created]
 */
const receivedToken = (jwt: string, expirationDelay: number) => ({
  type: AuthActionTypes.RECEIVED_TOKEN,
  payload: {
    jwt,
    expirationDelay,
  },
});

/**
 * [Dispatch this action to invalidate jwt]
 * @return {[object]}              [Action created]
 */
const invalidateToken = () => ({
  type: AuthActionTypes.INVALIDATE_TOKEN,
});

export default {
  receivedToken,
  invalidateToken,
};
